import lockupFile from '../../public/brand/lockup.svg?raw'
import markFile from '../../public/brand-mark.svg?raw'

/**
 * The Vieques Clasificados logo: a peace-sign hand whose two fingers make the V of Vieques, a navy fist, and the name beside it.
 * Two files, both traced from the approved artwork: the mark alone (public/brand-mark.svg, 244 by 344) and the mark with the
 * name (public/brand/lockup.svg, 1322 by 348). Every app icon is generated from the mark (npm run icons). See docs/BRAND.md.
 *
 * In the app it takes the colours of the look: the files' two paint colours become two named slots, --logo-ink (the fist and the
 * name; navy in the file) and --logo-accent (the V; teal in the file), which each look fills in (see index.css). White stays white.
 * The files themselves are untouched, so the icons and any outside use keep the approved colours.
 */
export const BRAND_ASPECT = 344 / 244 // mark: height over width
export const LOCKUP_ASPECT = 348 / 1322 // lockup: height over width

const themed = (file: string, label?: string) =>
  file
    .replace(/fill="#033262"/g, 'class="logo-ink"')
    .replace(/fill="#06b6c2"/g, 'class="logo-accent"')
    .replace('<svg ', `<svg class="logo-svg" ${label ? `role="img" aria-label="${label}"` : 'aria-hidden="true" focusable="false"'} `)

const LOCKUP = themed(lockupFile, 'Vieques Clasificados')
const MARK = themed(markFile)

/** Sized by CSS (`.brand-lockup`, `.brand-mark`), so every screen width can pick its own size. */
export default function BrandMark() {
  return <span className="brand-mark" dangerouslySetInnerHTML={{ __html: MARK }} />
}
export function BrandLockup() {
  return <span className="brand-lockup" dangerouslySetInnerHTML={{ __html: LOCKUP }} />
}
